/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCustomFilename.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/custom-filename";

export class AutogenModelCustomFilename<RowType extends ModelRow> extends Endpoint<RowType, RowCustomFilenameFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCustomFilename extends ModelRow<RowCustomFilenameFields> {
	constructor(values?: Partial<RowCustomFilenameFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCustomFilenameFields {
	filemask: string;
	node_config: string;
	node_name: string;
	sequence: number;
}

